// Edit planner for CREATE / DROP TYPE + DOMAIN (v2 Slice D4).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § Slice D4.
//
// Both ops append a fresh statement after the source statement (DSE2-7: no
// coalescing by default). The source statement kind is unrestricted — each op
// names the target type / domain directly.

import { rangeFromOffsets } from '../../../sql-grammar/document/lineIndex';
import type { DdlEdit, PlannedByteEdit } from '../../types';

import { pickAppendInsertion } from './appendInsertion';
import type { DdlEditCtx } from './applyDdlEdit';
import {
  synthesizeCreateUserDefinedType,
  synthesizeDropUserDefinedType,
} from './dialect.userDefinedType';

type UserDefinedTypeEdit = Extract<
  DdlEdit,
  { op: 'create-type' | 'drop-type' }
>;

export function planUserDefinedTypeEdit(
  ctx: DdlEditCtx,
  edit: UserDefinedTypeEdit,
): readonly PlannedByteEdit[] {
  const synth = synthForType(ctx, edit);
  const { offset: insertAt, sep, trailSep } = pickAppendInsertion(
    ctx.source,
    ctx.statementInfo.range.endOffset,
  );
  return [{
    range: rangeFromOffsets(ctx.lineIdx, insertAt, insertAt),
    replacement: sep + synth + trailSep,
    rationale: edit.op,
  }];
}

function synthForType(ctx: DdlEditCtx, edit: UserDefinedTypeEdit): string {
  switch (edit.op) {
    case 'create-type':
      return synthesizeCreateUserDefinedType(ctx.engine, edit.userType);
    case 'drop-type':
      return synthesizeDropUserDefinedType(
        ctx.engine,
        edit.typeName,
        edit.isDomain ?? false,
        edit.ifExists ?? false,
        edit.cascade ?? false,
      );
  }
}
